/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import { QueryParamNames } from '@powdr/constants';
import { normalizeLink } from '@powdr/utils';

export { wrapPageElement } from './src/components/page-wrapper';
export { wrapRootElement } from './src/components/root-wrapper';

// TODO: This is where we will manage scroll positon between routes
// Example https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#shouldUpdateScroll
// return false to stop return of scroll postion
const shouldUpdateScroll = ({
  // getSavedScrollPosition,
  prevRouterProps,
  routerProps,
}) => {
  const { location } = routerProps;
  const { pathname: path } = location || '';
  const { pathname: prevPath } = prevRouterProps?.location || '';
  const adjustedPrevPath = normalizeLink(prevPath);
  // console.log('prev saved', getSavedScrollPosition(prevRouterProps?.location || {}));

  if (location?.state?.isCancelScroll) {
    return false;
  }

  // prevent scroll when closing video modals
  if (location?.search?.includes(`${QueryParamNames.VIDEO}=`)
      || prevRouterProps?.location?.search?.includes(`${QueryParamNames.VIDEO}=`)
  ) {
    return false;
  }

  if (location?.search?.includes('?') && adjustedPrevPath === path) {
    return false;
  }

  return true;
};

const onRouteUpdate = ({ location }) => {
  if (typeof window !== 'undefined') {
    const previousPath = sessionStorage.getItem('currentPath') || '';
    const currentPath = location.pathname + location.search;

    sessionStorage.setItem('previousPath', previousPath);
    sessionStorage.setItem('currentPath', currentPath);
  }
};

export const onClientEntry = () => {
  if (process.env.NODE_ENV === 'development') {
    const originalError = console.error;
    console.error = (...args) => {
      // Filter out the defaultProps deprecation warning
      if (
        typeof args[0] === 'string'
        && args[0].includes('Support for defaultProps will be removed')
      ) {
        return; // skip the warning
      }
      originalError.apply(console, args);
    };
  }
};

export { shouldUpdateScroll, onRouteUpdate };
